
import { BarChart, PieChart, ShowChart, TableChartOutlined } from '@material-ui/icons';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import React from 'react';

export default function ToggleChart(props) {

    return (
        <ToggleButtonGroup sx={{ margin: 1 }} size='small'
            value={props.type || 'donut'}
            exclusive
            onChange={(e, newValue) => props.handleToggleView(newValue)}
            aria-label="view"
            style={{ fontSize: 10 }}
        >
            <ToggleButton value="bar" aria-label="grid view" size='small'>
                <BarChart color='primary' style={{ transform: 'rotate(90deg)', fontSize: 16}} size='small' />
            </ToggleButton>
            <ToggleButton value="donut" aria-label="card view" size='small'>
                <PieChart color='secondary' size='small' style={{ fontSize: 16}} />
            </ToggleButton>
            <ToggleButton value="column" aria-label="column view" size='small'>
                <BarChart color='primary' style={{ fontSize: 16}} />
            </ToggleButton>
            <ToggleButton value="line" aria-label="line view" size='small'>
                <ShowChart color='secondary' size='small' style={{ fontSize: 16}} />
            </ToggleButton>
            <ToggleButton value="table" aria-label="table view" size='small'>
                <TableChartOutlined color='primary' size='small' style={{ fontSize: 16}} />
            </ToggleButton>
        </ToggleButtonGroup>
    )
}
